import React from 'react';

import { titleCase, formatValue } from '../../base/common/utils';
import { ordersService } from './orders-service';

const HeaderSubcard = ({ data }) => {
  return (
    <div className="header-subcard">
      <div>
        <div className="img-container">
          <img src={data.logo_url} />
        </div>
        <div>
          <div className="amounts">
            <div className="sale">{formatValue(data.checkout_value_usd, 'currency')} Sale</div>
            <span className="pipe">|</span>
            <div className="earned">
              {formatValue(data.publisher_earnings_usd, 'currency')} Earned
            </div>
          </div>
          <div className="merchant-name">Fulfilled by {titleCase(data.merch_name)}</div>
        </div>
      </div>
      <div className="right-info">
        <div className="datetime">
          {ordersService.format(data.datetime_attributed_checkout, true)}
        </div>
      </div>
    </div>
  );
};

export default HeaderSubcard;
